import { Modal } from './';

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { pick } from 'lodash';

class FormModal extends Component {
  state = { isOpen: false, values: {} };

  open = () => this.setState({ isOpen: true, values: {} });
  close = () => this.setState({ isOpen: false, values: {} });

  set(name, value) {
    this.setState(({ values }) => ({
      values: { ...values, [name]: value },
    }));
  }

  submit() {
    const { defaultValues, onSubmit } = this.props;
    onSubmit(this.state.values, defaultValues);
  }

  onOpen = () => this.open();
  onClose = () => this.close();
  onSubmit = () => {
    this.submit();
    this.close();
  };
  onCancel = () => this.close();
  onReset = () => this.open();

  onFormInputChange = (event, { name, value }) => this.set(name, value);

  render() {
    const { id, Form, Actions, defaultValues, meta } = this.props;

    const formProps = {
      id: `${id}--form`,
      onSubmit: this.onSubmit,
    };
    const formValues = { ...defaultValues, ...this.state.values };

    const content = (
      <Modal.Content>
        <Form
          formProps={formProps}
          values={formValues}
          meta={meta}
          onInputChange={this.onFormInputChange}
        />
      </Modal.Content>
    );
    // FIXME: Is passing 'this' a good thing?
    const actions = <Actions formProps={formProps} modal={this} />;

    const modalProps = {
      open: this.state.isOpen,
      content: content,
      actions: actions,
      ...pick(this.props, 'id', 'trigger', 'header', 'content', 'actions'),
    };
    return (
      <Modal {...modalProps} onOpen={this.onOpen} onClose={this.onClose} />
    );
  }
}

FormModal.propTypes = {
  id: PropTypes.string.isRequired,
  Form: PropTypes.func.isRequired,
  Actions: PropTypes.func.isRequired,
  defaultValues: PropTypes.object.isRequired,
  meta: PropTypes.object,
  onSubmit: PropTypes.func.isRequired,
};

export default FormModal;



// WEBPACK FOOTER //
// ./src/components/FormModal.js